import { isDate } from "util";

/// <summary name='cafm.kendo' type='Object'>Container object for CAFM Kendo integration code</summary>
cafm.kendo = {
    /// <field name='ext' type='Object'>Contains kendo overrides / extension functions</field>
    ext: {
        init: function () {
            /// <summary>Sets up and applies the kendo integration code</summary>

            this.baseObservableSet = kendo.data.ObservableObject.fn.set;
            this.baseModelSet = kendo.data.Model.fn.set;
            this.datePicker.baseDatePickerSet = kendo.ui.DatePicker.fn.value;
            this.dateTimePicker.baseDateTimePickerSet = kendo.ui.DateTimePicker.fn.value;
            this.timePicker.baseTimePickerSet = kendo.ui.TimePicker.fn.value;

            // override the Kendo observable set method
            kendo.data.ObservableObject.fn.set = this.observableSet;
            // override the Kendo model set method
            kendo.data.Model.fn.set = this.modelSet;

            kendo.ui.DatePicker.fn.value = this.datePicker.value;

            kendo.ui.DateTimePicker.fn.value = this.dateTimePicker.value;

            kendo.ui.TimePicker.fn.value = this.timePicker.value;

            kendo.ui.ListView.fn.getSelected = this.listView.getSelected;

            kendo.ui.ListView.fn.getSelectedVal = this.listView.getSelectedVal;

            kendo.ui.ListView.fn.getSelectedId = this.listView.getSelectedId;

            kendo.ui.ListView.fn.toggleItem = this.listView.toggleItem;

            kendo.ui.ListView.fn.selectItem = this.listView.selectItem;

            kendo.ui.ListView.fn.deselectItem = this.listView.deselectItem;

            kendo.ui.Grid.fn.getSelectedRows = this.grid.getSelectedRows;

            kendo.ui.Grid.fn.toggleRow = this.grid.toggleRow;

            kendo.ui.Grid.fn.selectRow = this.grid.selectRow;

            kendo.ui.Grid.fn.deselectRow = this.grid.deselectRow;

            kendo.ui.Scheduler.fn.getGroupElements = this.scheduler.getGroupElements;

            kendo.ui.Scheduler.fn.getTimeSlotElementsForTimeCell = this.scheduler.getTimeSlotElementsForTimeCell;

            kendo.ui.Scheduler.fn.getAllTimeCellsForRoom = this.scheduler.getAllTimeCellsForRoom;

            kendo.ui.TreeView.fn.loadMoreOnDemand = this.treeView.loadMoreOnDemand;

            kendo.ui.TreeView.fn.loadMoreOnDemandAdd = this.treeView.loadMoreOnDemandAdd;

            kendo.ui.TreeView.fn.loadMoreOnDemandNode = this.treeView.loadMoreOnDemandNode;
        },
        /// <field name='baseObservableSet' type='Function'>Keeps reference to Kendo Observable set method</field>
        baseObservableSet: null,

        observableSet: function (arg1, arg2) {
            /// <summary>Sets a single property or multiple properties on the observable object</summary>
            /// <param name="arg1" type="Object">The property key string if setting a single property or an object of properties if setting multple properties</param>
            /// <param name="arg2" type="Object">The property object if setting a single property, otherwise don't provide this argument</param>

            var me = this;
            cafm.kendo.ext.set('Observable', me, arg1, arg2);
        },
        /// <field name='baseModelSet' type='Function'>Keeps reference to Kendo Model set method</field>
        baseModelSet: null,

        modelSet: function (arg1, arg2) {
            /// <summary>Sets a single property or multiple properties on the model object</summary>
            /// <param name="arg1" type="Object">The property key string if setting a single property or an object of properties if setting multple properties</param>
            /// <param name="arg2" type="Object">The property object if setting a single property, otherwise don't provide this argument</param>

            var me = this;
            cafm.kendo.ext.set('Model', me, arg1, arg2);
        },
        set: function (type, target, arg1, arg2) {
            /// <summary>Sets a single property or multiple properties on the model object</summary>
            /// <param name="type" type="String">The type of object the set is being performed on</param>
            /// <param name="target" type="Object">The object instance to call set on</param>
            /// <param name="arg1" type="Object">The property key string if setting a single property or an object of properties if setting multple properties</param>
            /// <param name="arg2" type="Object">The property object if setting a single property, otherwise don't provide this argument</param>

            var setMeth = cafm.kendo.ext['base{0}Set'.format(type)];
            // check if name is actually an object containing multiple props to set
            if (typeof (arg1) == 'object') {
                $.each(arg1, function (name, val) {
                    setMeth.call(target, name, val);
                });
            }
            else if (typeof (arg1) == 'string') {
                setMeth.call(target, arg1, arg2);
            }
            else {
                throw Error('Unexpected type pass to set method');
            }
        },

        datePicker: {
            /// <field name='baseDatePickerSet' type='function'>Base kendo date picker value method</field>
            baseDatePickerSet: null,
            value: function (value) {
                /// <summary>Gets or sets the date value</summary>
                /// <param name="value" type="Object">the date object or string</param>

                if (isStr(value)) {
                    if (cafm.util.dateStringIsMin(value)) {
                        value = '';
                    }
                    else {
                        value = cafm.util.ensureDate(value);
                    }
                }
                if (isDefined(value)) {
                    cafm.kendo.ext.datePicker.baseDatePickerSet.call(this, value);
                }
                else {
                    return cafm.kendo.ext.datePicker.baseDatePickerSet.call(this);
                }
            }
        },
        dateTimePicker: {
            /// <field name='baseDateTimePickerSet' type='function'>Base kendo datetime picker value method</field>
            baseDateTimePickerSet: null,
            value: function (value) {
                /// <summary>Gets or sets the datetime value</summary>
                /// <param name="value" type="Object">the date object or string</param>

                try {

                    if (isStr(value)) {
                        if (cafm.util.dateStringIsMin(value)) {
                            value = '';
                        }
                    }
                    if (isDefined(value)) {
                        cafm.kendo.ext.dateTimePicker.baseDateTimePickerSet.call(this, value);
                        let clientSettings = cafm.getClientSettings();
                        cafm.kendo.helpers.setSessionDateTimeVal(this.element, value, clientSettings.dateTimeMomentPattern, clientSettings.shortDateMomentPattern);
                    }
                    else {
                        return cafm.kendo.ext.dateTimePicker.baseDateTimePickerSet.call(this);
                    }
                }
                catch (err) {

                    alert(err.message);
                }
            }
        },
        timePicker: {
            /// <field name='baseTimePickerSet' type='function'>Base kendo time picker value method</field>
            baseTimePickerSet: null,
            value: function (value) {
                /// <summary>Gets or sets the time value</summary>
                /// <param name="value" type="String">The time string</param>

                if (isStr(value) && value.indexOf('T') > -1) {

                    value = kendo.toString(cafm.util.ensureDate(value), 't');
                }
                if (isDefined(value)) {

                    cafm.kendo.ext.timePicker.baseTimePickerSet.call(this, value);
                }
                else {

                    return cafm.kendo.ext.timePicker.baseTimePickerSet.call(this);
                }
            }
        },
        /// <field name='listView' type='Object'>Kendo listView extensions</field>
        listView: {
            toggleItem: function (item) {

                var theUid = item.data('uid');
                var wrapper = item.getLvWrapper();
                var uids = wrapper.getSelectedItemUids();

                if (uids.indexOf(theUid) < 0) {

                    uids.push(theUid);
                    item.addClass('k-state-selected');
                    item.attr('aria-selected', 'true');
                }
                else {

                    cafm.util.removeWhere(uids, function (uid) {

                        return uid == theUid;
                    });
                    item.removeClass('k-state-selected');
                    item.attr('aria-selected', 'false');
                }

                wrapper.setSelectedItemUids(uids);
            },
            selectItem: function (uid) {

                var wrapper = this.element.getLvWrapper();
                var item = wrapper.find('.cLvIt[data-key="{0}"]'.format(uid));
                var uids = wrapper.getSelectedItemUids();

                // add uid
                uids.push(theUid);

                // set selected state
                item.addClass('k-state-selected');
                item.attr('aria-selected', 'true');

                // set updated uids
                wrapper.setSelectedItemUids(uids);
            },
            deselectItem: function (uid) {

                var wrapper = this.element.getLvWrapper();
                var item = wrapper.find('.cLvIt[data-uid="{0}"]'.format(uid));
                var uids = wrapper.getSelectedItemUids();

                // remove uid
                cafm.util.removeWhere(uids, function (theUid) {

                    return uid == theUid;
                });

                // remove selected state
                item.removeClass('k-state-selected');
                item.attr('aria-selected', 'false');

                // set updated uids
                wrapper.setSelectedItemUids(uids);
            },
            getSelected: function () {
                /// <summary>Gets selected data items</summary>
                /// <returns type="Array">Array of data items</returns>

                var lv = this;
                var wrapper = $(lv.element).getLvWrapper();
                var uids = wrapper.getSelectedItemUids();
                var data = lv.dataSource.data();
                var items = [];
                if (uids && uids.length) {
                    $.each(uids, function (i, uid) {
                        var dataItem = cafm.util.findByFieldValue(data, 'uid', uid);
                        if (dataItem) {
                            items.push(dataItem);
                        }
                    });
                }
                switch (items.length) {
                    case 0:
                        return null;
                    case 1:
                        return items[0];
                    default:
                        return items;
                }
            },
            getSelectedVal: function (f) {
                /// <summary>Gets selected data items field values for the specified field name argument</summary>
                /// <param name="f" type="String">The field name of value to get</param>
                /// <returns type="Array">Array of values</returns>

                var items = this.getSelected();
                if (!items) return null;
                if (items.length > 1) {
                    var vals = [];
                    items.forEach(function (item, i) {
                        vals.push(item.get(f));
                    });
                    return vals;
                }
                else {
                    return items.get(f);
                }
            },
            getSelectedId: function () {
                /// <summary>Gets selected Id values</summary>
                /// <returns type="Array">Array of Id values</returns>

                return this.getSelectedVal('ID')
            }
        },
        grid: {
            toggleRow: function (row) {

                if (!isJQuery(row)) row = $(row);

                let grd = this,
                    grdEl = grd.element,
                    uids = grdEl.data('uids'),
                    theUid = row.data('uid'),
                    dataItem = grd.dataSource.getByUid(theUid),
                    lookupContainer;

                if (!dataItem) return false;

                if (!uids) {

                    lookupContainer = grdEl.closest('.lookupSearch');

                    if (lookupContainer.length)
                        uids = lookupContainer.data('uids');
                    else
                        uids = [];
                }

                if (uids.indexOf(dataItem.id) < 0) {
                    uids.push(dataItem.id);
                    row.addClass('k-state-selected');
                    row.attr('aria-selected', 'true');
                    row.find('.k-checkbox').prop('checked', true).attr('aria-checked', true);
                }
                else {
                    cafm.util.removeWhere(uids, uid => {
                        return uid == dataItem.id;
                    });
                    row.removeClass('k-state-selected');
                    row.attr('aria-selected', 'false');
                    row.find('.k-checkbox').prop('checked', false).attr('aria-checked', false);
                }

                if (!lookupContainer || !lookupContainer.length) {

                    grdEl.data('uids', uids);
                }
                else {

                    lookupContainer.data('uids', uids);
                }
                return true;
            },
            selectRow: function (row) {
                if (!isJQuery(row)) row = $(row);
                let grd = this,
                    grdEl = grd.element,
                    uids = grdEl.data('uids'),
                    theUid = row.data('uid'),
                    dataItem = grd.dataSource.getByUid(theUid);

                if (!dataItem) return false;

                // check for lookup
                if (!uids) {
                    lookupContainer = grdEl.parents('.lookupSearch:first');
                    uids = lookupContainer.data('uids');
                }
                if (uids.indexOf(dataItem.id) < 0) {
                    uids.push(dataItem.id);
                }
                row.addClass('k-state-selected');
                row.attr('aria-selected', 'true');
                row.find('.k-checkbox').prop('checked', true).attr('aria-checked', true);
                return true;
            },
            deselectRow: function (row) {
                if (!isJQuery(row)) row = $(row);
                let grd = this,
                    grdEl = grd.element,
                    uids = grdEl.data('uids'),
                    theUid = row.data('uid'),
                    dataItem = grd.dataSource.getByUid(theUid);

                if (!dataItem) return false;

                // check for lookup
                if (!uids) {
                    lookupContainer = grdEl.parents('.lookupSearch:first');
                    uids = lookupContainer.data('uids');
                }

                cafm.util.removeWhere(uids, function (uid) {
                    return uid == dataItem.id;
                });
                let rows = grdEl.select();
                rows.find('[data-uid="{0}"]'.format(dataItem.uid)).removeClass('k-state-selected');
                return true;
            },
            getSelectedRows: function () {
                /// <summary>Gets selected grid rows</summary>

                let grd = this,
                    items = [],
                    uids = grd.element.data('uids');
                if (cafm.util.hasItem(uids)) {
                    uids.forEach(id => {
                        let dataItem = grd.dataSource.get(id);
                        if (dataItem) items.push(dataItem);
                    });
                }
                return items;
            }
        },
        scheduler: {

            testZeroWidth: new RegExp(/\u200B/),
            getAllTimeCellsForRoom: function (roomGroupCell) {

                var timeCells = [roomGroupCell.next()];
                var prevCell = timeCells[0].html();
                timeCells[0].data('time', cafm.util.ensure24HourTime(prevCell));

                roomGroupCell.parent().nextAll().each(function (i, row) {

                    row = $(row);

                    var timeCell = row.find('> th:first');

                    if (timeCell.attr('data-roomid')) {

                        return false;
                    }
                    else {

                        var tct = timeCell.html();
                        if (tct !== '&nbsp;' && !cafm.kendo.ext.scheduler.testZeroWidth.test(tct)) {

                            tct = cafm.util.ensure24HourTime(tct);
                            prevCell = tct;
                        }
                        else if (prevCell) {

                            var t = prevCell.split(':');
                            var hour = t[0], min = t[1];

                            if (parseInt(min) == 0) {

                                min = 30;
                            }
                            else {

                                min = 0;
                            }

                            tct = '{0}:{1}'.format(hour, min);
                        }

                        timeCell.data('time', tct);

                        if (timeCell.length) {

                            timeCells.push(timeCell);
                        }
                    }
                });

                return timeCells;
            },
            getGroupElements: function () {

                return $('.k-scheduler-times th', this.view().element);
            },
            getTimeSlotElementsForTimeCell: function (timeCell) {

                // get the index of the time cell
                var timeCellIndex = timeCell.parent().index();

                // get the content cell 
                var contentCell = timeCell.parents('td:first').next();

                // get the adjacent timeslot cell
                var timeslotCell = contentCell.find('.k-scheduler-table > tbody > tr').eq(timeCellIndex).find('td');

                // return the timeslot cell(s)
                return timeslotCell;
            }
        },
        treeView: {

            loadMoreOnDemand: function (args) {

                var item = args.item,
                    parent = item.parents('.tvItem:first');

                if (!parent.length) {

                    parent = this.element;
                }

                var p = parent.data('page');

                if (!p) {
                    p = 1;
                }
                else {
                    p++;
                }

                this.dataSource.read({
                    Id: parent.data('key'),
                    Page: p
                });

                this.dataSource._requestInProgress = false;
            },
            loadMoreOnDemandAdd: function (args) {

                var items = args.items,
                    parent = args.parent,
                    loadMore = parent.find('.tvItemLoadMore');

                items = cafm.util.where(items, function (item) {

                    return !parent.find('[data-key="{0}"]'.format(item.Id)).length;
                });

                this.insertBefore(items, loadMore);
            },
            loadMoreOnDemandNode: function (args) {

                var res = args.response,
                    parentEl = $('[data-key="{0}"]'.format(args.parentId), this.element);

                if (!parentEl.length) {

                    parentEl = this.element;
                }

                parentEl.data('page', res.Page);

                if (res.Page > 1) {

                    // add the load more node
                    this.loadMoreOnDemandAdd({
                        parent: parentEl,
                        items: res.Items
                    });
                }

                var lm = $('.tvItemLoadMore', parentEl),
                    existingItems = parentEl.hasClass('cafmTv') ? parentEl.children(':not(.tvItemLoadMore)') : parentEl.find('> ul > li:not(.tvItemLoadMore)');

                // if total exceeds current items loaded...
                if (res.Total > existingItems.length && !lm.length) {

                    var loadMoreNode = { Description: cafm.res.str.LabelLoadMore, Css: 'tvItemLoadMore', Type: cafm.enums.TreeViewItemType.LoadMore };

                    if (parentEl.data('key')) {

                        this.append
                            (
                                loadMoreNode,
                                parentEl
                            );
                    }
                    else {

                        this.append
                            (
                                loadMoreNode
                            );
                    }
                }
                // otherwise remove the load more node element
                else if (res.Total <= existingItems.length && lm.length) {

                    this.remove(lm);
                }
            }
        },
        validator: {
            modify: function (v) {

                if (v) {

                    this.cafmValidation(v);
                }
            },
            cafmValidation: function (v) {

                var req = v.options.rules['required'], dat = v.options.rules['date'];

                v.options.rules['required'] = function (input) {

                    if (input.is('[required]')) {

                        let valid,
                            ph = input.attr('placeholder'),
                            isLc = input.hasClass('cfLookupInput'),
                            isTa = input[0].tagName == 'TEXTAREA';

                        cafm.kendo.ext.validator.positionValidator(input);

                        if (ph && input.val() == ph) {

                            input.val('');
                            valid = req(input);
                            cafm.kendo.ext.validator.onValidated(input, isLc, valid);
                            input.val(ph);
                            return valid;
                        }
                        else {

                            valid = req(input);
                            cafm.kendo.ext.validator.onValidated(input, isLc, valid);
                            return valid;
                        }
                    }

                    return true;
                }

                v.options.rules['bookingdatetime'] = function (input) {

                    if (input.is('[data-bookingdatetime-msg]')) {

                        cafm.kendo.ext.validator.positionValidator(input);

                        var pvm = input.getParentViewModel(), isValidArgs = {
                            startDate: pvm ? pvm.StartDate : null,
                            start: pvm ? pvm.StartDateTime : null,
                            end: pvm ? pvm.EndDateTime : null,
                            datePicker: input.data('kendoDatePicker')
                        }

                        var result = cafm.rb.helpers.isValidBookingDate(isValidArgs);

                        if (!result.valid) {

                            input.attr('data-bookingdatetime-msg', result.message);
                        }
                        else if (pvm.IsAdhocPattern && cafm.util.hasItem(pvm.BookingDateTimes)) {

                            isValidArgs.performAdhocChecksAgainstBookingOnly = true;
                            isValidArgs.roomBooking = pvm;
                            isValidArgs.dateTimes = pvm.BookingDateTimes;

                            $.each(pvm.BookingDateTimes, function (i, bdt) {

                                isValidArgs.startDate = bdt.StartDateTime;
                                isValidArgs.start = bdt.StartDateTime;
                                isValidArgs.end = bdt.EndDateTime;

                                result = cafm.rb.helpers.isValidBookingDate(isValidArgs);

                                if (!result.valid) {

                                    return false;
                                }
                            });
                        }

                        if (result.valid) {

                            input.closest('.cfField:not(.cfChildField)').find('.k-invalid-msg').remove();
                        }

                        return result.valid;
                    }

                    return true;
                }

                v.options.rules['date'] = function (input) {

                    if (input.is('[data-date-msg]')) {

                        cafm.kendo.ext.validator.positionValidator(input);

                        return input.attr('type').toLowerCase() == 'text' ? dat(input) : true;
                    }

                    return true;
                }

                v.options.rules['hoursmins'] = function (input) {

                    if (input.is('[data-hoursmins-msg]')) {

                        cafm.kendo.ext.validator.positionValidator(input, 'cfHoursMins');

                        var pvm = input.getParentViewModel(),
                            hours = pvm.Hours,
                            mins = pvm.Minutes;

                        if (!hours && !mins) {

                            return false;
                        }
                    }

                    return true;
                }

                v.options.rules['url'] = function (input) {

                    if (input.is('[data-url-msg]')) {

                        return new RegExp(/^(?:http(s)?:\/\/)+[\w.-]+(?:[\w-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/g).test(input.val());
                    }

                    return true;
                }
            },
            positionValidator: function (input, fieldClass) {

                var w = input;
                if (!w.hasClass('.cfField')) {

                    if (fieldClass) {

                        w = w.closest('.{0}:not(".cfChildField")'.format(fieldClass));
                    }
                    else {

                        w = w.closest('.cfField:not(".cfChildField")');
                    }

                    setTimeout(function () {
                        w.find('.k-invalid-msg').appendTo(w);
                    }, 10);
                }
            },
            onValidated: function (input, isLc, isValid) {

                if (isLc) {

                    let lc = input.parent(), lf = lc.parent();

                    if (isValid) {

                        lc.removeClass('k-invalid-field');
                        lf.find('.k-invalid-msg').remove();
                    }
                    else {

                        lc.addClass('k-invalid-field');
                    }
                }
                else {

                    var wrapper = input.closest('.cfField');
                    var inv = wrapper.find('.k-invalid-msg');

                    if (!inv.length) {

                        inv = wrapper.parent().find('.k-invalid-msg[data-for="{0}"]'.format(input.attr('name')));
                    }

                    if (isValid) {

                        if (wrapper.hasClass('k-invalid-field')) wrapper.removeClass('k-invalid-field');
                        if (wrapper.hasClass('k-invalid')) wrapper.removeClass('k-invalid');
                        if (inv.length) inv.remove();
                    }
                    else {

                        wrapper.addClass('k-invalid-field');
                    }
                }
            }
        }
    },
    bindings: {
        init: function () {

            kendo.data.binders.hiddenValue = this.hiddenValue();
            kendo.data.binders.checkedValue = this.checkedValue();
            kendo.data.binders.triCheckedValue = this.triCheckedValue();
            kendo.data.binders.basicList = this.basicList();
            kendo.data.binders.dateValue = this.dateValue();
            kendo.data.binders.keep = this.keep();
        },
        hiddenValue: function () {

            return kendo.data.Binder.extend({
                init: function (element, dataBind, roles) {

                    this.element = $(element);
                    this.dataBind = dataBind;
                    var me = this;
                    this.element.off('change').on({
                        change: function () {
                            me.setValue(me.element.val());
                        }
                    });
                },
                refresh: function (e) {

                    var viewModel = this.dataBind.hiddenValue.source;
                    var path = this.dataBind.hiddenValue.path;
                    if (e) {

                        this.element.val(viewModel.get(path));
                    }
                    else {

                        var value = viewModel.get(path);
                        this.element.val(value);
                    }
                },
                setValue: function (value) {

                    var viewModel = this.dataBind.hiddenValue.source;
                    var path = this.dataBind.hiddenValue.path;
                    if (viewModel && isFunc(viewModel.set)) {
                        viewModel.set(path, value);
                    }
                }
            })
        },
        checkedValue: function () {

            return kendo.data.Binder.extend({
                init: function (element, dataBind, roles) {

                    this.element = $(element);
                    this.dataBind = dataBind;
                    var me = this;
                    this.element.on({
                        change: function () {
                            me.setValue(isDefined(me.element.attr('checked')) || isDefined(me.element.attr('CHECKED')));
                        }
                    });
                },
                refresh: function (e) {

                    var viewModel = this.dataBind.checkedValue.source;
                    var path = this.dataBind.checkedValue.path;
                    var value = viewModel.get(path);
                    this.element.attr('checked', value);

                    var wrap = this.element.data('wrap');
                    if (wrap) {

                        wrap.setChecked(value, true);
                    }

                },
                setValue: function (value) {
                    var viewModel = this.dataBind.checkedValue.source;
                    var path = this.dataBind.checkedValue.path;
                    if (viewModel && isFunc(viewModel.set)) {
                        viewModel.set(path, value);
                    }
                }
            })
        },
        triCheckedValue: function () {

            return kendo.data.Binder.extend({
                init: function (element, dataBind, roles) {

                    this.element = $(element);
                    this.dataBind = dataBind;
                    var me = this;
                    this.element.on({
                        change: function () {
                            me.setValue(me.element.val());
                        }
                    });
                },
                refresh: function (e) {

                    var viewModel = this.dataBind.triCheckedValue.source;
                    var path = this.dataBind.triCheckedValue.path;
                    var value = viewModel.get(path);
                    this.element.val(value);

                    var wrap = this.element.data('wrap');
                    if (wrap) {
                        wrap.setTriCheckedState(value);
                    }
                },
                setValue: function (value) {
                    var viewModel = this.dataBind.triCheckedValue.source;
                    var path = this.dataBind.triCheckedValue.path;
                    if (viewModel && isFunc(viewModel.set)) {
                        viewModel.set(path, value);
                    }
                }
            })
        },
        basicList: function () {

            return kendo.data.Binder.extend({
                init: function (element, dataBind, roles) {

                    this.element = $(element);
                    this.dataBind = dataBind;

                    var me = this;
                    this.element.bind('change', function (e) {

                        var items = me.element.attr('data-items');

                        if (items) {

                            items = JSON.parse(items);
                        }
                        me.setValue(items);
                    });
                },
                refresh: function (e) {

                    var viewModel = this.dataBind.basicList.source;
                    var path = this.dataBind.basicList.path;
                    var items = viewModel.get(path);
                    this.element.data('items', items);

                    var source = this.element.data('source');
                    var sourceItems;

                    cafm.forms.basicList.clear({

                        listTarget: this.element,
                        suppressEvent: true
                    });

                    var setup = this.element.data('setup');

                    if (items && items.toJSON) {

                        items = items.toJSON();
                    }

                    if (items && items.length) {

                        var dataItems = [], addDataItem = function (dataItem) {

                            if (dataItem) {

                                var pushItem = {
                                    value: dataItem.value,
                                    text: dataItem.text
                                };

                                if (dataItem.required) {

                                    pushItem.required = dataItem.required;
                                }

                                dataItems.push(pushItem);
                            }
                        };

                        if (!setup && source) {

                            var sourceList = $('#' + source);
                            sourceItems = sourceList.data('items');
                            if (sourceItems) {

                                $.each(items, function (i, item) {

                                    var sourceItem = cafm.util.find(sourceItems, function (si) {

                                        if (item.value) {

                                            return si.value == item.value;
                                        }
                                        else {

                                            return si.value == item;
                                        }
                                    });

                                    addDataItem(sourceItem);
                                });
                            }
                        }
                        else if (items) {

                            if (source) {

                                sourceList = $('#' + source);
                                sourceItems = sourceList.data('sourceItems');
                            }

                            $.each(items, function (i, item) {

                                if (isStr(item) && source) {

                                    item = cafm.util.find(sourceItems, function (si) {

                                        if (item.value) {

                                            return si.value == item.value;
                                        }
                                        else {

                                            return si.value == item;
                                        }
                                    });
                                }

                                if (isStr(item) && source) {

                                    item = cafm.util.find(sourceItems, function (si) {

                                        if (item.value) {

                                            return si.value == item.value;
                                        }
                                        else {

                                            return si.value == item;
                                        }
                                    });
                                }

                                addDataItem(item);
                            });
                        }

                        if (dataItems.length) {

                            cafm.forms.basicList.add({

                                listTarget: this.element,
                                dataItem: dataItems,
                                suppressEvent: true
                            });

                            if (!setup && source) {

                                sourceList.data('sourceItems', sourceList.data('items'));

                                $.each(dataItems, function (i, dataItem) {

                                    cafm.forms.basicList.remove({

                                        listTarget: sourceList,
                                        suppressEvent: true
                                    }, dataItem);
                                });
                            }
                        }

                        this.element.data('setup', true);
                    }
                },
                setValue: function (value) {
                    var viewModel = this.dataBind.basicList.source;
                    var path = this.dataBind.basicList.path;
                    if (viewModel && isFunc(viewModel.set)) {
                        viewModel.set(path, value);
                    }
                }
            })
        },
        dateValue: function () {

            return kendo.data.Binder.extend({
                init: function (element, dataBind, roles) {

                    var t = this;
                    t.element = $(element);
                    t.dataBind = dataBind;

                    t.element.off('change.dv').on('change.dv', function (e) {

                        t.setValue($(e.currentTarget).val());
                    });
                },
                refresh: function (e) {

                    var t = this;
                    var dv = t.dataBind.dateValue;
                    var vm = dv.source;
                    var v = vm.get(dv.path);

                    if (t.element.data('fieldtype') == cafm.enums.InputType.DateTime) {

                        v = t.refreshDateTime(v);
                    }
                    else {

                        v = t.refreshDate(v);
                    }

                    t.element.val(v);
                    cafm.kendo.helpers.setSessionDateTimeVal(t.element, v, "YYYY-MM-DDTHH:mm", "YYYY-MM-DD");

                },
                refreshDate: function (v) {

                    if (!v) return null;

                    if (!isDate(v)) {

                        v = cafm.util.ensureDate(v);
                    }

                    if (cafm.browsers.supportsInput('date')) {

                        v = cafm.util.toUtcDate(v);

                        if (v) {
                            v = v.toJSON().slice(0, 10);
                        }
                    }
                    else {

                        v = cafm.util.toDateStringKeepKind(v, 'd');
                    }

                    return v;
                },
                refreshDateTime: function (v) {

                    if (!v) return null;

                    if (cafm.browsers.supportsInput('datetime-local')) {
                        if (v) {
                            if (isDate(v)) {
                                v = moment(v).format().slice(0, 16);
                            } else {
                                v = v.slice(0, 16);
                            }
                        }
                    }
                    else {

                        v = cafm.util.toDateStringKeepKind(v, 'g');
                    }

                    return v;
                },
                setValue: function (value) {

                    if (isStr(value)) {

                        value = kendo.parseDate(value);
                    }

                    var t = this;
                    var vm = t.dataBind.dateValue.source;
                    var path = t.dataBind.dateValue.path;
                    if (vm && isFunc(vm.set)) {
                        vm.set(path, value);
                    }
                }
            })
        },
        keep: function () {

            return kendo.data.Binder.extend({
                init: function (element, dataBind, roles) {

                    this.element = $(element);
                    this.dataBind = dataBind;
                },
                refresh: function (e) {

                    var viewModel = this.dataBind.keep.source,
                        path = this.dataBind.keep.path;

                    if (!viewModel.get(path)) {

                        this.element.remove();
                    }
                }
            })
        }
    },
    helpers: {
        /**
         * @summary Sets value of Session Date time control visible to User,based on new UTC value of the hidden control
         * @param {element} utcElem databound element with UTC datetime
         * @param {datetime} utcDt, the new UTC Date
         * @param {string} fmtDateTime, datetime format of target Session Date Time control 
         * @param {string} fmtDateOnly, datetime format of target Session Date Only control 
         */
        setSessionDateTimeVal: function (utcElem, utcDt, fmtDateTime, fmtDateOnly) {
            var element = $(utcElem);
            var wrapper = element.closest('[id^=dtWrapper]');
            var dtkind = element.data('dtkind');
            if (element.data('dtkind') === 'utc' || element.data('dtkind') === 'from-utc' || element.data('dtkind') === 'to-utc') {

                var localCtr = $('#sessionDate', wrapper);
                if (localCtr) {
                    if ($(localCtr).data('session_dt_changing') === 1) {
                        $(localCtr).data('session_dt_changing', 0);
                    } else {
                        setTimeout(function () {
                            var dtLocal;
                            var formatted = null;
                            if (utcDt) {
                                switch (dtkind) {
                                    case 'from-utc':
                                    case 'to-utc':
                                        dtLocal = cafm.web.funcs.fromUTCToSessionDateOnly(utcDt);
                                        formatted = moment(dtLocal).format(fmtDateOnly);
                                        break;
                                    default:
                                        dtLocal = cafm.web.funcs.fromUTCToSessionDateTime(utcDt);
                                        formatted = moment(dtLocal).format(fmtDateTime);
                                        break;
                                }
                            }
                            $(localCtr).val(formatted);
                        }, 0);
                    }
                }
            }
        },
        getViewModelFromChangeArgs: function (args) {

            var vm;
            if (args.sender.uid) { // check is the view model
                vm = args.sender;
            }
            else if (args.sender.source) {
                vm = args.sender.source;
            }
            else {
                throw Error('View model object not determined');
            }

            return vm;
        },
        /**
         * Shows correct Today in DatePicker control based on Session Time Zone
         * @param {any} opts
         */
        fixTodayOnDatePickerOpen: function (opts) {

            opts.open = function () {

                var datePicker = this;
                var dateView = datePicker.dateView;

                if (isNullOrUndefined(dateView.calendar)) { return;}

                var dtLocal = cafm.web.funcs.fromUTCToSessionDateOnly(cafm.web.funcs.getNowUTC());
                var dateTxt = moment(dtLocal).format(cafm.util.browserDateFormat());

                var selectToday = function () {
                    datePicker.value(dtLocal);
                    dateView.popup.close();
                    return false;
                };

                //set new seleted date to new today only if no value is currently selected.
                if (isNullOrUndefined(datePicker.value())) {
                    dateView.value(dateTxt);
                    var existingToday = $("td.k-today", dateView.calendar.element);
                    existingToday.removeClass('k-today');

                    var newToday = $("td.k-state-selected.k-state-focused", dateView.calendar.element);
                    newToday.removeClass('k-state-selected').addClass('k-today');
                    newToday.off('click').on('click', function () {
                        return selectToday();
                    });

                }

                //always show correct footer
                let footerAnch = $('a.k-link.k-nav-today', dateView.calendar.element);
                var ftTxt = moment(dtLocal).format('DD MMM yyyy');
                footerAnch.text(ftTxt);
                footerAnch.off('click').on('click', function ()
                {
                    return selectToday();
                });
            }
        }
    }
}